import { CATEGORY_HIERARCHY } from 'shared/enums/category';
import { IConstructorGroup } from 'shared/types/ConstructorGroup';

/**
 * [isValidProductType]
 * takes in currentChild that is a IConstructorGroup
 * and returns whether it has a group_id that matches
 * the productType
 */

export const isValidProductType = (currentChild: IConstructorGroup, productType: string) => {
  return currentChild.group_id === productType;
};

/**
 * [isValidCategoryPage]
 * takes in  productType, and a subType that come from the
 * pathname and the group hierarchy returned from constructor
 * and returns whether this is a route
 * supported to be a catrgory page
 */
export const isValidCategoryPage = ({
  productType,
  subType,
  groups,
}: {
  productType: string;
  subType: string;
  groups: IConstructorGroup[];
}) => {
  if (CATEGORY_HIERARCHY?.[productType]?.[subType]) {
    return true;
  }

  // first group returned from constructor is the master group
  if (groups?.[0]?.group_id === 'all') {
    const allGroups = groups?.[0];
    const productTypes = allGroups.children;
    const productTypeGroup = productTypes.find((type) => isValidProductType(type, productType));

    if (productTypeGroup?.children && subType) {
      const result = productTypeGroup.children.find((type) => isValidProductType(type, subType));
      if (result) {
        return true;
      }
    }

    return false;
  }

  return false;
};
